import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const IconMoveHor = props => (
  <SvgIcon {...props} viewBox="0 0 16.0002 10.0001">
    <path d="m12 2.0001c0-1.1046 0.89543-2 2-2s2 0.89543 2 2-0.89543 2-2 2-2-0.89543-2-2zm0 6c0-1.1046 0.89543-2 2-2s2 0.89543 2 2-0.89543 2-2 2-2-0.89543-2-2zm-6-6.0001c0-1.1046 0.8954-2 2-2s2 0.89543 2 2-0.8954 2-2 2-2-0.8954-2-2zm0 6c0-1.1046 0.8954-2 2-2s2 0.8954 2 2-0.8954 2-2 2-2-0.8954-2-2zm-6-6c0-1.1046 0.89543-2 2-2s2 0.89543 2 2-0.8954 2-2 2-2-0.8954-2-2zm0 6c0-1.1046 0.89543-2 2-2s2 0.8954 2 2-0.8954 2-2 2-2-0.8954-2-2z" />
  </SvgIcon>
);

export default IconMoveHor;



// WEBPACK FOOTER //
// ./src/components/icons/IconMoveHor.js